import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../Config";

async function claroLoginFetch(code, signal) {
  const response = await fetch(`${config.loginClaro.claroLoginApi}/claro/auth/lp/openid`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "omit",
    body: JSON.stringify({ code }),
    signal,
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    const message =
      (data && (data.message || data.error)) ||
      `HTTP ${response.status} ${response.statusText}`;
    throw new Error(message);
  }

  return data
}

export default function AuthCallback() {
  const navigate = useNavigate();
  const [erro, setErro] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const processarLogin = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");

        if (!code) {
          setErro(true);
          setTimeout(() => navigate("/auth/login"), 2000);
          return;
        }

        const data = await claroLoginFetch(code, controller.signal);

        if (data?.entities) {
          const agente = {
            matricula: String(data.entities?.matricula || ""),
            agenteUsuarioId: String(data.entities?.idUsuario || ""),
            nome: String(data.entities?.fullname || "")
          };

          localStorage.setItem("@claro-lp/agente", JSON.stringify(agente));

        } else {
          throw new Error("Resposta inválida: matrícula não encontrada.");
        }

        navigate(config.url.urlLp);
      } catch (error) {
        console.error("Erro ao fazer login:", error);
        setErro(true);
        setTimeout(() => navigate("/auth/login"), 2000);
      }
    };

    processarLogin();
    return () => controller.abort();
  }, [navigate]);

  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-[#F5F7FA]">
      <div className="flex flex-col items-center gap-4">
        {!erro ? (
          <p className="text-lg text-gray-700">Processando login...</p>
        ) : (
          <>
            <svg
              className="h-12 w-12 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            <p className="text-lg text-gray-700">
              Erro ao processar login. Redirecionando...
            </p>
          </>
        )}
      </div>
    </div>
  );
}
